import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const VerifyAdminLoginOtpSlice = createSlice({
    name: "verifyAdminLoginOtpRequest",
    initialState,
    reducers: {
        verifyAdminLoginOtpRequest(state) {
            state.loading = true;
        },
        verifyAdminLoginOtpRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        verifyAdminLoginOtpRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        verifyAdminLoginOtpStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    verifyAdminLoginOtpRequest,
    verifyAdminLoginOtpRequestSuccess,
    verifyAdminLoginOtpRequestError,
    verifyAdminLoginOtpStateReset,
} = VerifyAdminLoginOtpSlice.actions;

export default VerifyAdminLoginOtpSlice.reducer;